import { gecinaBlueMain } from '../../../theme'
import { Box, Grid } from '@mui/material'
import React from 'react'
import FiltresHistoriqueDepensesManuelles from './FiltresHistoriqueDepensesManuelles'

const EnteteHistoriqueDepensesManuelles = () => (
	<Box sx={{ background: gecinaBlueMain, minHeight: '192px', paddingX: '172px' }}>
		<Grid container item xs={12} justifyContent="space-between" sx={{ pt: 5 }}>
			<Box sx={{ fontFamily: 'BlackerDisplay', fontSize: 28, fontWeight: 900 }}>
				Historique des dépenses manuelles
			</Box>
		</Grid>

		<Grid container item xs={12} justifyContent="space-evenly" sx={{ pt: 5 }}>
			<FiltresHistoriqueDepensesManuelles />
		</Grid>
	</Box>
)

export default EnteteHistoriqueDepensesManuelles